import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./i18n";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();

function FallbackUI() {
  return (
    <div role="alert" style={{ padding: 24 }}>
      <h1>Une erreur est survenue.</h1>
      <p>L&apos;équipe a été notifiée. Veuillez rafraîchir la page.</p>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
